import { proxy } from 'valtio'
import { derive, devtools } from 'valtio/utils'
import { type ApiCallType } from '../types/ApiCallType'
import { type GlobalCustomerType } from '../types/GlobalCustomerType'
import { type GlobalCustomerCardType } from '../types/GlobalCustomerCardType'
import { type GlobalCustomerAchType } from '../types/GlobalCustomerAchType'
import { type Customer } from './customersProxy'
import { type Transaction } from './transactionsProxy'

export enum CustomerTabType {
  CustomerDetails = 'details',
  CustomerTransactions = 'transactions',
  CustomerCards = 'cards'
}

export interface CustomerProxyType {
  apiCall: ApiCallType
  apiCallCustomerCardsSearch: ApiCallType
  apiCallCustomerAchSearch: ApiCallType
  apiCallCustomerUpdate: ApiCallType
  apiCallCustomerTransactionSearch: ApiCallType
  apiCallCustomerCardDelete: ApiCallType
  apiCallCustomerCardMakePrimary: ApiCallType
  customer: GlobalCustomerType | null
  customerCard: GlobalCustomerCardType | null
  achAccount: GlobalCustomerAchType | null
  selectedParentCustomer: Customer | null
  currentParentCustomer: GlobalCustomerType | null
  childCompanies: Customer[] | null
  displayEditSlideOver: boolean
  displayDeleteModal: boolean
  selectedTab: string
  displayParentSearchSection: boolean
  customerCards: GlobalCustomerCardType[]
  achAccounts: GlobalCustomerAchType[]
  customerTransactions: Transaction[]
}

const baseProxy = proxy({
  achAccount: null,
  achAccounts: [],
  apiCall: {
    error: null,
    loading: false
  },
  apiCallCustomerAchSearch: {
    error: null,
    loading: false
  },
  apiCallCustomerCardDelete: {
    error: null,
    loading: false
  },
  apiCallCustomerCardMakePrimary: {
    error: null,
    loading: false
  },
  apiCallCustomerCardsSearch: {
    error: null,
    loading: false
  },
  apiCallCustomerTransactionSearch: {
    error: null,
    loading: false
  },
  apiCallCustomerUpdate: {
    error: null,
    loading: false
  },
  childCompanies: null,
  currentParentCustomer: null,
  customer: null,
  customerCard: null,
  customerCards: [],
  customerTransactions: [],
  displayDeleteModal: false,
  displayEditSlideOver: false,
  displayParentSearchSection: false,
  selectedParentCustomer: null,
  selectedTab: CustomerTabType.CustomerDetails
})

export const customerProxy = derive({}, { proxy: baseProxy }) as CustomerProxyType

devtools(customerProxy, { name: 'customerProxy' })
